import React from "react";
import MetaTags from "../components/MetaTags";
import { getBreadcrumbSchema } from "../utils/schemaGenerator";
import "../components/css/Terms.css";
import TermsCom from "../components/TermsCom";

const Terms = () => {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Terms of Use', url: '/terms' }
  ]);

  return (
    <div className="terms-page">
      <MetaTags
        title="Terms of Use | BookMyAudition"
        description="Review BookMyAudition terms of use, platform policies, user obligations, and audition guidelines."
        keywords="BookMyAudition terms of use, terms and conditions, audition platform terms"
        canonical="https://web.bookmyaudition.com/terms"
        schema={breadcrumbSchema}
      />
      <div className="terms-wrapper">
         <div className="terms-container">
          <h1 className="terms-title">Terms of Use</h1>
          <TermsCom />
         </div>
      </div>
    </div>
  );
};

export default Terms;